export function formPost (url, params) {
  const tmpForm = document.createElement('form')
  const win = window.open('', 'emuForm','height=1159,width=719,top=0,left=0,toolbar=no,menubar=no,scrollbars=no,resizable=no, location=no,status=no')
  tmpForm.action = url
  tmpForm.target = 'emuForm'
  tmpForm.method = 'post'
  tmpForm.style.display = 'none'
  for (const item in params) {
    const opt = document.createElement('textarea')
    opt.name = item
    opt.value = params[item]
    tmpForm.appendChild(opt)
  }
  document.body.appendChild(tmpForm)
  tmpForm.submit()
  return win
}
